<template>
<div class="chapter">
<div class="inner_page">
<p class="pt" id="pt1"><span href="#/xhtml/contents#c_pt1" title="Link target outside of Sample"><span class="epub-b">PART ONE EARLY YEARS</span></span></p>
<p class="img1"><img alt="image" height="549" src="images/pg1.jpg" width="403"/></p>
<p class="cap">Leroy Eldridge Cleaver, Mug Shot, June 1954</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?4158e709